export enum ActionEventType {
  ERROR,
  NOTIFICATION,
}

export namespace ActionEventType {
  let elements = [ActionEventType.ERROR, ActionEventType.NOTIFICATION];
  let alias = "com.bcdfx.model.ActionEventType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
